import { defineMessages } from "react-intl";

export default defineMessages({
    accountSummaryTextPara1Text: {
        "id": "create-account.component.create-account-form.createAccountSummaryPara1Text",
        "defaultMessage": "Manage your policies, pay bills, file and check on a claim, and update your contact information. You can see policy and transaction details, review your statements, and choose to go paperless."
    },
    showemailaddressfieldPara: {
        "id": "create-account.component.create-account-form.The email address used with this account should belong to ",
        "defaultMessage": "The email address used with this account should belong to "
    },
    showconfirmemailaddressPara1: {
        "id": "create-account.component.create-account-form.Please confirm that ",
        "defaultMessage": 'Please confirm that '
    },
    showconfirmemailaddressPara3: {
        "id": "create-account.component.create-account-form.showconfirmemailaddressPara3",
        "defaultMessage": ' is correct. We’ll email you a verification code. It’s needed to continue with your account setup.'
    },
    continue: {
        "id": "create-account.component.create-account-form.Continue",
        "defaultMessage": "Continue"
    },
    policyNotFoundError: {
        "id": "create-account.component.create-account-form.policy-search.policyNotFoundError",
        "defaultMessage": "The information entered doesn’t match our records. Please recheck your policy or billing statement and reenter."
    },
    enrollmentAlreadyExistsError: {
        "id": "create-account.component.create-account-form.policy-search.enrollmentAlreadyExistsError",
        "defaultMessage": "An account already exists with this policy number. Please click Log in to access your account."
    },
    policyNotServiceableError: {
        "id": "create-account.component.create-account-form.policy-search.policyNotServiceableError",
        "defaultMessage": "The policy you entered is ineligible to add to the account. For help, email onlineservices@amig.com."
    },
    policySearchAPIError: {
        "id": "create-account.component.create-account-form.policy-search.policySearchAPIError",
        "defaultMessage": "We have encountered an issue processing your request. Please try again later or contact our Customer Service team at 1-800-543-2644 for further assistance."
    },
    emailAlreadyExistsError: {
        "id": "create-account.component.create-account-form.enter-email.emailAlreadyExistsError",
        "defaultMessage": "That email address is already connected to another policy number. Please click Log in to access your account."
    }

});